import {PolymerElement, html} from '@polymer/polymer';
import {PanelDynamicRegionBehavior} from '../behaviors/panel-dynamic-region-behavior.js';

class KeliPanelToolbar extends PanelDynamicRegionBehavior(PolymerElement) {
  static get template() {
    return html`
<style>
  :host {
    box-sizing: border-box;
    white-space: nowrap;
    display: none;
    padding: 5px;
    flex-direction: row;
    flex-wrap: wrap;
    background-color: var(--keli-toolbar-background);
  }

  :host(.visible) {
    display: flex;
  }

  ::slotted(.input-field) {
    flex: 1 0 150px;
    margin: 0 5px 5px 5px;
  }

  ::slotted(keli-button) {
    margin: 0;
    --keli-button-text-color: var(--keli-toolbar-color);
    --keli-button-border-color: var(--keli-toolbar-border-color); 
  }

  ::slotted(keli-value) {
    padding: 0 10px;
    min-height: auto;
  }
</style>

<slot></slot>`;
  }

  static get is() {
    return 'keli-panel-toolbar';
  }

  handleRegionVisibilityChanged(newValue) {
    this.classList.toggle('visible', newValue);
  }
}

customElements.define(KeliPanelToolbar.is, KeliPanelToolbar);
export {KeliPanelToolbar};
